module.exports = __webpack_public_path__ + "static/media/contentful.3c600a83.png";